// Ödemeler sayfasına rolden bağımsız, dinamik yetki politikasıyla erişim
export const PAYMENTS_PERMISSION_KEYS = {
    viewPage: "viewPaymentsPage"
};
